import { render, staticRenderFns } from "./newCreateResource.vue?vue&type=template&id=5aab18c8&scoped=true"
import script from "./newCreateResource.vue?vue&type=script&lang=js"
export * from "./newCreateResource.vue?vue&type=script&lang=js"
import style0 from "./newCreateResource.vue?vue&type=style&index=0&id=5aab18c8&prod&scoped=true&lang=css"
import style1 from "./newCreateResource.vue?vue&type=style&index=1&id=5aab18c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab18c8",
  null
  
)

export default component.exports